import React from 'react'
import { ShimmerPostDetails } from "react-shimmer-effects";

const SuspenseCard = () => {
  return (
    <ShimmerPostDetails card cta variant="SIMPLE" />
  )
}

export default SuspenseCard